var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCustomerInfo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 49,
  fill: "none",
  viewBox: "0 0 40 49"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeWidth: 2,
  d: "M3 1.5h34a2 2 0 0 1 2 2v34.86a2 2 0 0 1-.505 1.328l-6.347 7.14a2 2 0 0 1-1.495.672H3a2 2 0 0 1-2-2v-42a2 2 0 0 1 2-2Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#00AED9",
  fillRule: "evenodd",
  d: "M22.917 13.9a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-.19 4.137a5 5 0 1 0-5.554.043c-2.155.928-3.756 2.885-4.159 5.252a1 1 0 0 0 1.972.335c.4-2.355 2.485-4.167 5.014-4.167s4.614 1.812 5.014 4.168a1 1 0 0 0 1.972-.336c-.41-2.405-2.054-4.385-4.26-5.295",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M11 30.5h18M11 36.5h12"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#00619E",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M31 47.5v-8a1 1 0 0 1 1-1h7"
})));
export default SvgCustomerInfo;